// Görünüm tercihi (açık / koyu / sistem): cihaz başına `localStorage.vegaColorMode`, varsayılan açık. Uygulanan
// değer `html[data-bs-theme]`dir; ilk boyamadan önce aynısını public/index.html'deki satır içi betik yapar (açık
// sayfanın koyuya "yanıp sönmemesi" için). Koyu görünüm `light-dark()` ister; tanımayan tarayıcıda seçenek gizlenir
// ve sayfa açık kalır. Kural: docs/styleguide/koyu-gorunum.md.
import { ref } from 'vue';

const STORAGE_KEY = 'vegaColorMode';
export const COLOR_MODES = ['light', 'dark', 'system'];

const systemQuery = typeof window !== 'undefined' && window.matchMedia
  ? window.matchMedia('(prefers-color-scheme: dark)')
  : null;

export function isColorModeSupported() {
  return typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('color', 'light-dark(#000, #fff)');
}

export function getColorMode() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return COLOR_MODES.includes(stored) ? stored : 'light';
  } catch (e) {
    return 'light';
  }
}

function resolve(mode) {
  if (!isColorModeSupported()) return 'light';
  if (mode === 'system') return systemQuery && systemQuery.matches ? 'dark' : 'light';
  return mode === 'dark' ? 'dark' : 'light';
}

// Uygulanan görünüm ('light' | 'dark'); JS ile renk veren bileşenler (grafik paleti, utils/chartColors.js) bunu
// okuyup görünüm değişince yeniden çizilir.
export const resolvedColorMode = ref('light');

export function applyColorMode(mode = getColorMode()) {
  const value = resolve(mode);
  document.documentElement.setAttribute('data-bs-theme', value);
  resolvedColorMode.value = value;
}

export function setColorMode(mode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch (e) {
    // Depolama kapalıysa tercih bu oturumla sınırlı kalır.
  }
  applyColorMode(mode);
}

// "Sistem" seçiliyken işletim sistemi görünümü değişince sayfa da değişir.
export function initColorMode() {
  applyColorMode();
  if (systemQuery && systemQuery.addEventListener) {
    systemQuery.addEventListener('change', () => {
      if (getColorMode() === 'system') applyColorMode('system');
    });
  }
}
